const userAgent = navigator.userAgent;
const platform = navigator.platform;
export const isIOS = /iphone|ipad|ipod/i.test(userAgent);
export const isAndroid = /android/i.test(userAgent);
export const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/i.test(platform);
export const isWindows = /Win32|Win64|Windows|WinCE/i.test(platform);
export const isDesktop = !isIOS && !isAndroid;
export const isFirefox = /firefox|fxios/i.test(userAgent);
export const isEdge = /edg/i.test(userAgent);
export const isSamsung = /samsungbrowser/i.test(userAgent);
export const isChrome =
  /chrome|crios|chromium/i.test(userAgent) && !isEdge && !isSamsung;
export const isSafari =
  /safari/i.test(userAgent) && !isChrome && !isFirefox && !isEdge && !isSamsung;

export const chromeURL = 'googlechrome://';
export const firefoxURL = 'firefox://';
export const firefoxURLPrefix = 'firefox://open-url?url=';
export const edgeURL = 'microsoft-edge://';
export const samsungURL = 'samsunginternet://';

export const getBrowserURL = (href?: string) => {
  const url = href?.replace(/^https?:\/\//, '') ?? '';
  if (isChrome) return `${chromeURL}${url}`;
  if (isFirefox && url.length) return `${firefoxURLPrefix}${url}`;
  if (isFirefox) return `${firefoxURL}`;
  if (isEdge) return `${edgeURL}${url}`;
  if (isSamsung) return `${samsungURL}${url}`;
  return href;
};
